import React from 'react';
import ButtonBack from './images/x.png';

function News( { onClose }  ) {

  return (
    <div className="dashboard-news">
    <div className="news-container">
    <button className="button-close1" onClick={onClose}>
    <img src={ButtonBack} />
    </button>
        <div className="news-content">
        <div className="news-content-header"><h1>NEWS</h1></div>
        <div className="news-content-subheader"><h2>Version 1.0 - MVP / ALPHA</h2><div className="line6"></div></div>
        <div className="news-content-subheader"><h3>NEW UPDATES</h3></div>
        <div className="news-content-text"><p>A tempor commodo ac netus tellus sed a risus. Adipiscing dolor in eu aliquet aliquet aliquet interdum fames neque. In aliquet pharetra dictum risus. Mauris scelerisque sed sagittis a adipiscing nulla imperdiet dis. Augue sed vel non pellentesque pellentesque netus nullam consectetur turpis.</p></div>
        <div className="news-content-subheader"><h3>UPCOMING UPDATES</h3></div>
        <div className="news-content-text"><p>A tempor commodo ac netus tellus sed a risus. Adipiscing dolor in eu aliquet aliquet aliquet interdum fames neque. In aliquet pharetra dictum risus. Mauris scelerisque sed sagittis a adipiscing nulla imperdiet dis. Augue sed vel non pellentesque pellentesque netus nullam consectetur turpis.</p></div>
        <div className="news-content-subheader"><h2>Version 1.0 - MVP / ALPHA</h2><div className="line6"></div></div>
        <div className="news-content-subheader"><h3>UPCOMING UPDATES</h3></div>
        <div className="news-content-text"><p>A tempor commodo ac netus tellus sed a risus. Adipiscing dolor in eu aliquet aliquet aliquet interdum fames neque. In aliquet pharetra dictum risus. Mauris scelerisque sed sagittis a adipiscing nulla imperdiet dis. Augue sed vel non pellentesque pellentesque netus nullam consectetur turpis.</p></div>
        </div>
    </div>
    </div>
  );
}

export default News;